import { EncryptionSearchKeywords } from './encryption.types';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { ColumnValue } from '../../../../../../grid/types/common';
import { SelectOption } from '../../../../../../ui/gzDropdown/types';
import {
  EncryptionMode,
  EncryptionModule,
  EncryptionExclusionItemType,
} from '@nirvana/shared/dtos/types/policies/common';

export const ENCRYPTION_DEFAULT_VALUE: EncryptionModule = {
  enabled: false,
  mode: EncryptionMode.DECRYPT,
  encryptPolicy: {
    tpm: {
      shouldAskForPassword: false,
    },
  },
  exclusions: {
    enabled: false,
    items: [],
  },
};

// get selectable type values
export function getExclusionItemTypeFormOptions(): Array<SelectOption> {
  return [
    {
      title: getLabelByExclusionItemType(EncryptionExclusionItemType.MOUNT_POINT),
      value: EncryptionExclusionItemType.MOUNT_POINT,
    },
    {
      title: getLabelByExclusionItemType(EncryptionExclusionItemType.PARTITION_NAME),
      value: EncryptionExclusionItemType.PARTITION_NAME,
    },
    {
      title: getLabelByExclusionItemType(EncryptionExclusionItemType.VOLUME_ID),
      value: EncryptionExclusionItemType.VOLUME_ID,
    },
  ];
}
// get exclusion item type grid values
export function getExclusionItemTypeGridValues(): Array<ColumnValue> {
  return [
    {
      label: getLabelByExclusionItemType(EncryptionExclusionItemType.MOUNT_POINT),
      value: EncryptionExclusionItemType.MOUNT_POINT,
    },
    {
      label: getLabelByExclusionItemType(EncryptionExclusionItemType.PARTITION_NAME),
      value: EncryptionExclusionItemType.PARTITION_NAME,
    },
    {
      label: getLabelByExclusionItemType(EncryptionExclusionItemType.VOLUME_ID),
      value: EncryptionExclusionItemType.VOLUME_ID,
    },
  ];
}
// get label by exclusion item type value
export function getLabelByExclusionItemType(type: EncryptionExclusionItemType): string {
  switch (type) {
    case EncryptionExclusionItemType.MOUNT_POINT:
      return translateFn('Drive letter');
    case EncryptionExclusionItemType.PARTITION_NAME:
      return translateFn('Label / Name');
    case EncryptionExclusionItemType.VOLUME_ID:
      return translateFn('GUID');
  }
}

// searchable keywords
export function getEncryptionSearchKeywords(): { [type in EncryptionSearchKeywords]: SearchableKeyword } {
  return {
    [EncryptionSearchKeywords.EncryptionManagement]: {
      translatedLabel: translateFn('Encryption'),
      label: 'Encryption',
    },
    [EncryptionSearchKeywords.Decrypt]: {
      translatedLabel: translateFn('Decrypt'),
      label: 'Decrypt',
    },
    [EncryptionSearchKeywords.Encrypt]: {
      translatedLabel: translateFn('Encrypt'),
      label: 'Encrypt',
    },
    [EncryptionSearchKeywords.TrustedPlatformModule]: {
      translatedLabel: translateFn('Trusted Platform Module'),
      label: 'Trusted Platform Module',
    },
    [EncryptionSearchKeywords.Tpm]: {
      translatedLabel: translateFn('TPM'),
      label: 'TPM',
    },
    [EncryptionSearchKeywords.Exclusions]: {
      translatedLabel: translateFn('Exclusions'),
      label: 'Exclusions',
    },
  };
}
